const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaItens: [],
	listaSelect: [],
    listaGrupoFaturamentoRadiologista: [],
    listaContratoItem: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LAUDO_IMPORTACAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LAUDO_IMPORTACAO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'LAUDO_IMPORTACAO_LISTADO':            
            return {
                ...state, 
                lista: action.payload.data
            };
        
        case 'LAUDO_IMPORTACAO_ITEM_LISTADO':
            return {
                ...state, 
                listaItens: action.payload.data
            };
        
        case 'LAUDO_GRUPO_FATURAMENTO_RADIOLOGISTA_LISTADO':
            return {
                ...state, 
                listaGrupoFaturamentoRadiologista: action.payload.data
            };

        case 'LAUDO_CONTRATO_ITEM_LISTADO':
            return {
                ...state, 
                listaContratoItem: action.payload.data
            };

        default:
            return state;
    }
}
